import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import { version } from '../../../package.json';

const useStyles = makeStyles((theme) => ({
  text: {
    color: theme.palette.text.hint,
  },
}));

export const Copyright = () => {
  const classes = useStyles();
  return (
    <div className={classes.text}>
      <Typography align="center">
        Copyright © LEO {new Date().getFullYear()} v{version}
      </Typography>
    </div>
  );
};

export default Copyright;
